import React, { Component } from 'react';

export default class ReferTermCondition extends Component {
  render() {
    return (
      <div className="container refer-term-condition">
        <div className="row">
        <div>
          <h1>Terms &amp; Conditions</h1>
        <p>Referred Successfully means your friend has signed-up for the ﬁrst time on the OkkJi Mobile App using your referral code &amp; have successfully completed his/her ﬁrst travel with Goibibo.</p>
        <p>Incase the friend you've referred is already registered on OkkJi previously, there won't any referral bonus given.</p>
        <p>You can refer as many people as you want in 1 calendar month, but the beneﬁt of Rs.150 will be only for 5 people in a monthYou will get beneﬁt of Rs.150 only if your friend completes any travel of Transaction value &gt; Rs.500earned through booking cashbacks on Goibibo has a validity of 1 calendar month. goCash+ earned through other means have a variable expiry, please check for the expiry date on the statement. Added through top-up or cancellation refunds has no expiry.</p>        
        <p>For details on usage of Udhar, <span className="text-blue">Click Here</span></p>
        </div>
        </div>
      </div>
    )
  }
}
